export const SUCCESS_STATUS = "SUCCESS";
export const FAILURE_STATUS = "FAILURE";
export const DEFAULT_ERROR_MSG = "Something went wrong";
export const DEFAULT_IMAGE_LINK = "https://robbreport.com/wp-content/uploads/2022/03/mbn01.jpg?w=1000";
export const DEFAULT_MODEL_VALUE = "OTHER_MODEL";
export const DEFAULT_BRAND_VALUE = "OTHER_BRAND";
export const SELL_ORDER_TYPE = "SELL_ORDER_TYPE";

export const BICYCLE_COMPANY_EMAIL = "support@bicyclecompany.in";